import { PkDivider } from '@uefadigital/panenka-react';
import { useMemo, lazy, Suspense } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import ErrorBoundary from '@shared/ErrorBoundary';
import FormGuide from '@shared/match-summary/FormGuide';
import HeadToHead from '@shared/match-summary/HeadToHead';
import Lineups from '@shared/match-summary/Lineups';
import MatchInfo from '@shared/match-summary/MatchInfo';
import Standings from '@shared/match-summary/Standings';
import useMatch from '@shared/MatchUnit/useMatch';
import { useTranslateFn } from '@shared/Translate';
import { matchLineupsAvailable } from '@utilities/live';

const PotmCard = lazy(() => import(/* webpackPrefetch: true */ '@shared/PotmCard'));

const MatchInfoColumn = ({
  options,
  options: { content, matchOptions, showPotm, potmStatTypes, isFemaleCompetition, newTableFormat },
}) => {
  const t = useTranslateFn();
  const window = useWindowSize();
  const match = useMatch(matchOptions.match);

  const modulesOptions = useMemo(
    () => ({
      ...options,
      match,
    }),
    [match, options],
  );

  if ((!window.isDesktop && content !== 'PREMATCH') || !match.homeTeam || !match.awayTeam) return null;

  const showLineups = !content || content === 'LINEUPS';
  const showOthers = !content || content === 'PREMATCH';
  return (
    <>
      {showLineups && (
        <>
          {showPotm && match?.playerOfTheMatch && (
            <Suspense>
              <PotmCard match={match} statTypes={potmStatTypes} isFemaleCompetition={isFemaleCompetition} />
            </Suspense>
          )}
          {matchLineupsAvailable(match) && (
            <ErrorBoundary>
              <h2 className='match-info__title'>{t('lineups')}</h2>
              <Lineups options={modulesOptions} />
              {showOthers && <PkDivider className='card-divider' />}
            </ErrorBoundary>
          )}
        </>
      )}
      {showOthers && (
        <>
          <h2 className='match-info__title'>{t('team_information')}</h2>
          {newTableFormat && match.group && (
            <ErrorBoundary>
              <Standings options={modulesOptions} />
            </ErrorBoundary>
          )}
          <ErrorBoundary>
            <FormGuide options={modulesOptions} />
          </ErrorBoundary>
          <ErrorBoundary>
            <HeadToHead options={modulesOptions} />
            <PkDivider className='card-divider' />
          </ErrorBoundary>
          <h2 className='match-info__title'>{t('match_information')}</h2>
          <ErrorBoundary>
            <MatchInfo options={modulesOptions} />
          </ErrorBoundary>
        </>
      )}
    </>
  );
};

export default MatchInfoColumn;
